export var IFilterByOwnerValues;
(function (IFilterByOwnerValues) {
    IFilterByOwnerValues[IFilterByOwnerValues["ALL"] = 0] = "ALL";
    IFilterByOwnerValues[IFilterByOwnerValues["OWNED"] = 1] = "OWNED";
})(IFilterByOwnerValues || (IFilterByOwnerValues = {}));
